import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faBox, faBuilding, faCalendarDays, faChartBar, faChartLineUp, faChartSimple, faChartUser, faClipboardCheck, faClipboardList, faFileInvoiceDollar, faFileShield, faFileSignature, faGear, faGridHorizontal, faHandHoldingDollar, faHandsHoldingDollar, faHome, faNewspaper, faSackDollar, faScreenUsers, faShip, faTag, faTrain, faTruck, faUser, faUserLock, faUsersRectangle, faVault } from "@fortawesome/pro-light-svg-icons";

export type SidebarMenuProps = {
    groups: MenuGroupProps[];
}

export type MenuGroupProps = {
    key: string;
    label?: string;
    icon?: IconProp;
    expanded?: boolean;
    collapsible?: boolean;
    items: MenuItemProps[];
}

export type MenuItemProps = {
    key: string;
    text: string;
    icon: IconProp;
    href?: string;
    active?: boolean;
    permissions?: string[];
}

const SidebarMenu: SidebarMenuProps = {
    groups: [
        {
            key: 'main',
            expanded: true,
            items: [
                {
                    key: 'home',
                    text: 'Home',
                    icon: faHome,
                    href: '/'
                },
                {
                    key: 'myPerformance',
                    text: 'My Performance',
                    icon: faChartUser,
                    href: '/users/administrators/my/performance',
                    permissions: []
                },
            ]
        },
        {
            key: 'users',
            label: 'USERS',
            collapsible: true,
            expanded: true,
            items: [
                {
                    key: 'companies',
                    text: 'Companies',
                    icon: faBuilding,
                    href: '/users/companies',
                    permissions: ['companies.read.all', 'companies.read.me']
                },
                {
                    key: 'customers',
                    text: 'Customers',
                    icon: faUser,
                    href: '/users/customers',
                    permissions: ['customers.read.all', 'customers.read.me']
                },
                {
                    key: 'administrators',
                    text: 'Administrators',
                    icon: faUserLock,
                    href: '/users/administrators',
                    permissions: ['administrators.read.all']
                },
                {
                    key: 'vendors',
                    text: 'Vendors',
                    icon: faUsersRectangle,
                    href: '/operationals/vendors',
                    permissions: ['vendors.read.all']
                }
            ]
        },
        {
            key: 'orders',
            label: 'ORDERS',
            collapsible: true,
            expanded: true,
            items: [
                {
                    key: 'orderSummary',
                    text: 'Order Summary',
                    icon: faChartSimple,
                    href: '/orders/dashboard',
                    permissions: ['orders.read.all', 'orders.read.me']
                },
                {
                    key: 'offers',
                    text: 'Offers List',
                    icon: faTag,
                    href: '/offers/list',
                    permissions: ['offers.read.all', 'offers.read.me']
                },
                {
                    key: 'orders',
                    text: 'Orders List',
                    icon: faFileInvoiceDollar,
                    href: '/orders/list',
                    permissions: ['orders.read.all', 'orders.read.me']
                },
                {
                    key: 'goods',
                    text: 'Goods List',
                    icon: faBox,
                    href: '/goods',
                    permissions: []
                }
            ]
        },
        {
            key: 'finance',
            label: 'FINANCE',
            collapsible: true,
            expanded: true,
            items: [
                {
                    key: 'dashboard',
                    text: 'Dashboard',
                    icon: faChartLineUp,
                    href: '/finance',
                    permissions: []
                },
                {
                    key: 'outcomes',
                    text: 'Outcomes',
                    icon: faSackDollar,
                    href: '/finance/outcomes',
                    permissions: ['outcomes.invoices.read.all', 'outcomes.invoices.payments.read.all']
                },
                {
                    key: 'incomes',
                    text: 'Incomes',
                    icon: faFileInvoiceDollar,
                    href: '/finance/incomes',
                    permissions: ['orders.read.all', 'orders.read.me']
                },
                {
                    key: 'deposits',
                    text: 'Deposits',
                    icon: faHandsHoldingDollar,
                    href: '/finance/deposits',
                    permissions: ['deposits.read.all']
                }
            ]
        },
        {
            key: 'operationals',
            label: 'OPERATIONALS',
            collapsible: true,
            expanded: true,
            items: [
                {
                    key: 'operations',
                    text: 'Operations',
                    icon: faClipboardCheck,
                    href: '/operations',
                    permissions: []
                },
                {
                    key: 'ships',
                    text: 'Ships',
                    icon: faShip,
                    href: '/operationals/ships',
                    permissions: ['ships.read.all']
                },
                {
                    key: 'trains',
                    text: 'Trains',
                    icon: faTrain,
                    href: '/operationals/trains',
                    permissions: ['trains.read.all']
                },
                {
                    key: 'trucks',
                    text: 'Trucks',
                    icon: faTruck,
                    href: '/operationals/trucks',
                    permissions: ['trucks.read.all']
                },
                {
                    key: 'internalDocuments',
                    text: 'Internal Document',
                    icon: faFileShield,
                    href: '/operationals/documents',
                    permissions: []
                },
            ]
        },
        {
            key: 'humanResource',
            label: 'HR',
            collapsible: true,
            expanded: false,
            items: [
                {
                    key: 'employeeContracts',
                    text: 'Contracts',
                    icon: faFileSignature,
                    href: '/hr/contracts',
                    permissions: ['employees.contracts.read.all']
                },
                {
                    key: 'payslips',
                    text: 'Payslips',
                    icon: faHandHoldingDollar,
                    href: '/hr/payslips',
                    permissions: ['employees.payslips.read.all']
                },
                {
                    key: 'leaves',
                    text: 'Leaves',
                    icon: faCalendarDays,
                    href: '/hr/leaves',
                    permissions: ['employees.leaves.read.all']
                }
            ]
        },
        {
            key: 'vessels',
            label: 'VESSELS',
            collapsible: true,
            expanded: false,
            items: [
                {
                    key: 'vessels',
                    text: 'Vessels List',
                    icon: faShip,
                    href: '/vessels',
                    permissions: ['vessels.read.all']
                },
                {
                    key: 'requisitions',
                    text: 'Requisitions List',
                    icon: faClipboardList,
                    href: '/vessels/requisitions',
                    permissions: ['vessels.requisitions.read.all', 'vessels.requisitions.read.me']
                }
            ]
        }
    ]
};

const SidebarFarMenu: SidebarMenuProps = {
    groups: [
        {
            key: 'settings',
            expanded: true,
            items: [
                {
                    key: 'news',
                    text: 'News',
                    icon: faNewspaper,
                    href: '/settings/news',
                    permissions: ['news.read.all']
                },
                {
                    key: 'settings',
                    text: 'Settings',
                    icon: faGear,
                    href: '/settings',
                    permissions: ['roles.create']
                }
            ]
        }
    ]
};

export { SidebarMenu, SidebarFarMenu };